export default{
  hasShownModal: false
}



// WEBPACK FOOTER //
// ./src/helpers/global.js